export default __webpack_public_path__ + "static/mar-crm-cx-6f4b444cd39918c81c41972d67bf1542.png";